/**
 * Icons for the execution list, shared by the desktop and mobile renderers.
 * Inline SVG drawn with `currentColor`, so they follow the theme: the CSS
 * sets the colour and size, the icon only carries its shape and weight.
 * Shapes follow the Lucide set (MIT) for the pin and the ×; the check is a
 * deliberately heavy stroke.
 */

const attrs = (weight, fill = "none") =>
  `viewBox="0 0 24 24" fill="${fill}" stroke="currentColor" stroke-width="${weight}" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"`;

/** Bold checkmark. `weight` is the stroke width in viewBox units (default 3.5). */
export function checkIcon(weight = 3.5) {
  return `<svg ${attrs(weight)}><path d="M20 6 9 17l-5-5"/></svg>`;
}

/** Pin: outline when idle, solid when `filled` (the item is pinned). */
export function pinIcon(filled = false) {
  return `<svg ${attrs(2, filled ? "currentColor" : "none")}>
    <path d="M12 17v5"/>
    <path d="M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z"/>
  </svg>`;
}

/** × for "take off the list". */
export function xIcon(weight = 2.5) {
  return `<svg ${attrs(weight)}><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>`;
}

/** Six-dot grip for reordering execution items. */
export function dragHandleIcon() {
  return `<svg ${attrs(0, 'currentColor')}>${[6, 12, 18].map(y =>
    `<circle cx="9" cy="${y}" r="1.6"/><circle cx="15" cy="${y}" r="1.6"/>`).join('')}</svg>`;
}
